export default __webpack_public_path__ + "static/cosesy-423aedad41eb450d52b7c5dd63c14f7a.svg";